import moment from "moment";

export const getRegions = (storesList) => {
  if (!storesList.length) return [];
  return storesList.map((s) => s.location);
};

export const getStores = (storesList, region) => {
  if (storesList.length === 0 || region === "") {
    return [];
  }
  const matchingRegion = storesList.find((s) => s.location === region);
  return matchingRegion.stores;
};

export const getAllStores = (storesList) => {
  if (storesList.length === 0) {
    return [];
  }
  let storeArray = [];
  for (let i = 0; i < storesList.length; i++) {
    const particularLocStore = storesList[i].stores;
    for (let j = 0; j < particularLocStore.length; j++) {
      storeArray.push(particularLocStore[j]);
    }
  }
  return storeArray;
};

export const sortArrayByTime = (array, timeKey) => {
  function compare(a, b) {
    const timeA = a[timeKey];
    const timeB = b[timeKey];

    let comparison = 0;
    if (moment(timeA).isAfter(timeB)) {
      comparison = -1;
    } else if (moment(timeA).isBefore(timeB)) {
      comparison = 1;
    }
    return comparison;
  }
  return array.sort(compare);
};
